import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getPatientComplianceAnalytic } from "app/services/dashboard/patientComplianceAnalyticService";

import { BASE_URL } from "static/constants";

export const patientComplianceAnalyticApi = createApi({
  reducerPath: "patientComplianceAnalyticApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  endpoints: ({ query }) => ({
    getPatientComplianceAnalytic: query({
      queryFn: ({ yearlyFilter, accountFilter }) => {
        return {
          data: getPatientComplianceAnalytic({
            yearlyFilter,
            accountFilter,
          }),
        };
      },
    }),
  }),
});

export const { useGetPatientComplianceAnalyticQuery } =
  patientComplianceAnalyticApi;
